import { render } from "./SchoolCourseAccess.vue?vue&type=template&id=51b3a300&scoped=true"
import script from "./SchoolCourseAccess.vue?vue&type=script&lang=js"
export * from "./SchoolCourseAccess.vue?vue&type=script&lang=js"

import "./SchoolCourseAccess.vue?vue&type=style&index=0&id=51b3a300&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b3a300"]])

export default __exports__